// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Grid, {GridItem} from 'sail/Grid';
import ContentList, {ContentListItem} from 'sail/ContentList';
import {CaptionCapsTextProps, CaptionCaps} from 'sail/Text';
import Card from 'sail/Card';
import {AlignBox} from 'sail/Align';

import StartCheckerFooter from './StartCheckerFooter';
import SEPANumberDropdown from './SEPANumberDropdown';
import type {IntegrationCheckersDataIntegrationCheckerScenarioResult} from '../../generatedTypes';
import AcceptASEPADebitPaymentScenarios from './AcceptASEPADebitPaymentScenarios';
import AcceptACardPaymentScenarios from './AcceptACardPaymentScenarios';

type Props = {
  results: Array<IntegrationCheckersDataIntegrationCheckerScenarioResult>,
  runCheckers: () => void,
  loadingCheckers: boolean,
  error: Object,
  loginCTARedirectTarget: string,
  siteUrl: string,
  currentMerchant: ?string,
  dashboardUrl: string,
  integrationCheckerName: string,
};

type State = {
  selectedTestNumberSet: string,
};

class IntegrationCheckersSelectableSection extends React.Component<
  Props,
  State,
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedTestNumberSet: '',
    };
  }

  getScenariosByCheckerName() {
    switch (this.props.integrationCheckerName) {
      case 'accept_a_payment':
        return (
          <AcceptACardPaymentScenarios
            dashboardUrl={this.props.dashboardUrl}
            results={this.props.results}
          />
        );
      case 'sepa_debit_accept_a_payment':
        return (
          <AcceptASEPADebitPaymentScenarios
            dashboardUrl={this.props.dashboardUrl}
            results={this.props.results}
            country={this.state.selectedTestNumberSet}
          />
        );
      default:
        return null;
    }
  }

  handleOnSEPAAccountNumberChange = (e: string) => {
    this.setState({selectedTestNumberSet: e});
  };

  render() {
    const {
      results,
      runCheckers,
      loadingCheckers,
      error,
      loginCTARedirectTarget,
      siteUrl,
      dashboardUrl,
      currentMerchant,
      integrationCheckerName,
    } = this.props;
    const paymentCount = results
      .map((result) => (result && result.target_object_id ? 1 : 0))
      .reduce((accumulator, value) => accumulator + value);

    if (
      window.siteAnalytics &&
      window.siteAnalytics.trackIntegrationCheckerResults
    ) {
      window.siteAnalytics.trackIntegrationCheckerResults(results, {
        guide: integrationCheckerName,
      });
    }

    return (
      <React.Fragment>
        <Grid direction="horizontal" spacing={{horizontal: 26}}>
          <GridItem columnSpan={3} column={10} row={1} />
        </Grid>

        <Card style={{width: '100%'}} margin={{vertical: 20}} shadow="keyline">
          <ContentList style={{width: '100%', marginLeft: 0}}>
            <ContentListItem
              background="offset"
              title={
                <Box padding={{top: 4}}>
                  <CaptionCaps>Test scenario</CaptionCaps>
                </Box>
              }
              startAlign="center"
              endAlign="center"
              end={
                integrationCheckerName === 'sepa_debit_accept_a_payment' ? (
                  <AlignBox reference={CaptionCapsTextProps}>
                    <Box>
                      <CaptionCaps>Test account number</CaptionCaps>{' '}
                    </Box>
                    <Box padding={{left: 8}}>
                      <SEPANumberDropdown
                        onChange={this.handleOnSEPAAccountNumberChange}
                      />
                    </Box>
                  </AlignBox>
                ) : (
                  <Box>
                    <CaptionCaps>Test card number</CaptionCaps>{' '}
                  </Box>
                )
              }
            />
            {this.getScenariosByCheckerName()}
            <StartCheckerFooter
              runCheckers={runCheckers}
              loadingCheckers={loadingCheckers}
              paymentCount={paymentCount}
              disabled={!currentMerchant}
              loginCTARedirectTarget={`${siteUrl}${loginCTARedirectTarget}`}
              dashboardUrl={dashboardUrl}
              error={error}
              integrationChecker={integrationCheckerName}
            />
          </ContentList>
        </Card>
        <Box />
      </React.Fragment>
    );
  }
}

export default IntegrationCheckersSelectableSection;
